module.exports = __webpack_public_path__ + "static/media/291962.84953f74.png";